import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { Chart, Line } from 'react-chartjs-2'
import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { TableFormats } from '../TableHelpers'
import { NONE, TRACKER_LAUNCH_VIEW, TRACKER_PRE_POST_VIEW, TRACKER_TIMELINE_VIEW } from '../../constants/commons'
import { AVERAGE_BENCHMARK, TRACKER_BENCHMARK1, TRACKER_BENCHMARK2, TRACKER_BENCHMARK3, TRACKER_BENCHMARK4, TRACKER_PRIMARY, WHITE } from '../../constants/colors'
import DateHelpers from '../../classes/DateHelpers'

export class DailyEngagement extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    trackerId: PropTypes.string,
    trackerPlan: PropTypes.object,
    trackerTimelineMetrics: PropTypes.object,
    trackerAverageBenchMarkPlan: PropTypes.object,
    trackerAverageBenchMarkTimelineMetrics: PropTypes.object,
    trackerData: PropTypes.array,
    primarySelect: PropTypes.object,
    benchmarkSelect1: PropTypes.object,
    benchmarkSelect2: PropTypes.object,
    benchmarkSelect3: PropTypes.object,
    benchmarkSelect4: PropTypes.object,
    averageBenchmarkData: PropTypes.array,
    averageBenchmarkSelect: PropTypes.object,
    dailyEngagementTeasersTrailers: PropTypes.object,
    handleTrackerData: PropTypes.func,
    blueLineIndex: PropTypes.number,
    trackerDataList: PropTypes.array,
    maxValue: PropTypes.number,
    selectedView: PropTypes.string,
    handleMaxValue: PropTypes.func,
    selectedTrackerEntities: PropTypes.array
  }

  constructor (props) {
    super(props)

    this.state = {
      maxValue: 0,
      teaserTrailerPrimary: null,
      teaserTrailerBenchmark1: null,
      teaserTrailerBenchmark2: null,
      teaserTrailerBenchmark3: null,
      teaserTrailerBenchmark4: null
    }
  }


  componentDidMount () {
    this.setupTrackerData (false)
    Chart.pluginService.register({
      afterDraw: function (chart) {
        if (chart.tooltip._active && chart.tooltip._active.length && chart.config.type === 'line' && chart.config.data.datasets[0].label === 'Primary') {
          const activePoint = chart.controller.tooltip._active[0]
          const ctx = chart.ctx
          const x = activePoint.tooltipPosition().x
          const topY = chart.scales['y-axis-0'].top
          const bottomY = chart.scales['y-axis-0'].bottom
          ctx.save()
          ctx.beginPath()
          ctx.moveTo(x, topY)
          ctx.lineTo(x, bottomY)
          ctx.lineWidth = 1
          ctx.strokeStyle = '#808184'
          ctx.setLineDash([0])
          ctx.stroke()
          ctx.restore()
        }
      }
    })
  }

  componentDidUpdate (prevProps) {
    if ((prevProps.trackerPlan !== this.props.trackerPlan && this.props.trackerPlan.details && ((JSON.stringify(prevProps.selectedTrackerEntities) !== JSON.stringify(this.props.selectedTrackerEntities)))) || (prevProps.trackerTimelineMetrics !== this.props.trackerTimelineMetrics && this.props.trackerTimelineMetrics.details && ((JSON.stringify(prevProps.selectedTrackerEntities) !== JSON.stringify(this.props.selectedTrackerEntities)))) || (prevProps.trackerPlan !== this.props.trackerPlan && this.props.trackerPlan.details && prevProps.selectedView !== this.props.selectedView) || (prevProps.trackerTimelineMetrics !== this.props.trackerTimelineMetrics && this.props.trackerTimelineMetrics.details)) {
      this.setupTrackerData (false)
    } else if (this.props.primarySelect && prevProps.trackerPlan === this.props.trackerPlan && this.props.trackerPlan.details && prevProps.selectedView !== this.props.selectedView) {
      this.setupTrackerData (true)
    } else if (this.props.primarySelect && (JSON.stringify(prevProps.selectedTrackerEntities) !== JSON.stringify(this.props.selectedTrackerEntities))) {
      this.setupTrackerData (true)
    }
    if (this.props.primarySelect && prevProps.trackerId === this.props.trackerId && prevProps.trackerPlan !== this.props.trackerPlan && this.props.trackerPlan.details && ((JSON.stringify(prevProps.selectedTrackerEntities) === JSON.stringify(this.props.selectedTrackerEntities))) || (this.props.primarySelect && prevProps.trackerId === this.props.trackerId && prevProps.trackerTimelineMetrics !== this.props.trackerTimelineMetrics && this.props.trackerTimelineMetrics.details && ((JSON.stringify(prevProps.selectedTrackerEntities) === JSON.stringify(this.props.selectedTrackerEntities))))) {
      // Condition for benchmark dropdown change for same tracker
      this.setupTrackerData (true)
    }
    if (prevProps.trackerAverageBenchMarkPlan !== this.props.trackerAverageBenchMarkPlan || prevProps.trackerAverageBenchMarkTimelineMetrics !== this.props.trackerAverageBenchMarkTimelineMetrics) {
      this.setupTrackerData (false)
    }
  }

  setupTrackerData (isViewChanged) {
    let trackerData = []
    let trackerDataList = []
    let primarySelect = null
    let benchmarkSelect1 = null
    let benchmarkSelect2 = null
    let benchmarkSelect3 = null
    let benchmarkSelect4 = null
    let averageBenchmarkData = []
    let averageBenchmarkSelect = null

    const selectedView = this.props.selectedView ? this.props.selectedView : TRACKER_LAUNCH_VIEW
    const tracker = selectedView === TRACKER_LAUNCH_VIEW ? this.props.trackerPlan && this.props.trackerPlan.details : selectedView === TRACKER_PRE_POST_VIEW ? this.props.trackerPlan && this.props.trackerPlan.details : this.props.trackerTimelineMetrics && this.props.trackerTimelineMetrics.details
    const averageBenchMarkTracker = selectedView === TRACKER_LAUNCH_VIEW ? this.props.trackerAverageBenchMarkPlan && this.props.trackerAverageBenchMarkPlan.details : selectedView === TRACKER_PRE_POST_VIEW ? this.props.trackerAverageBenchMarkPlan && this.props.trackerAverageBenchMarkPlan.details : this.props.trackerAverageBenchMarkTimelineMetrics && this.props.trackerAverageBenchMarkTimelineMetrics.details
    const primaryTracker = tracker && tracker.primary_tracker
    if (primaryTracker) {
      trackerData.push(primaryTracker)
    }
    const defaultbenchmarks = tracker && tracker.benchmarks ? tracker.benchmarks.filter(b => b.is_default_benchmark) : []
    defaultbenchmarks.map(b => trackerData.push(b))
    const nonDefaultbenchmarks = tracker && tracker.non_defaultbenchmarks? tracker.non_defaultbenchmarks.sort((a, b) => (a.name < b.name) ? -1 : (a.name > b.name) ? 1 : 0) : []
    nonDefaultbenchmarks.map(b => trackerData.push(b))
    trackerData.length > 0 && trackerData.map(t => {
      const values = selectedView === TRACKER_LAUNCH_VIEW ? t.metrics.filter(t => t.day < 0).map(m => m.value) : t.metrics && t.metrics.map(m => m.value)
      const data = {
        name: t.name,
        trackerEntityId: t.tracker_entity_id,
        trackerId: tracker.tracker_topic.tracker_id,
        metrics: t.metrics,
        data: values,
        labels: selectedView === TRACKER_LAUNCH_VIEW ? t.metrics.filter(t => t.day < 0).map(m => m.day) : selectedView === TRACKER_PRE_POST_VIEW ? t.metrics.map(m => m.day) : t.metrics.map(m => m.date),
        isPrimary: t.is_primary,
        dayZeroData: selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? t.metrics.filter(t => t.day === 0).map(m => m.value) : '',
        maxValue: Math.max.apply(Math, values),
        lookbackDate: t.lookback_date
      }
      trackerDataList.push(data)
    })
    // Support for "None" in benchmark dropdowns
    trackerDataList.push({
      name: NONE,
      metrics: [],
      data: [],
      labels: [],
      isPrimary: false
    })
    averageBenchmarkData = this.getAverageBenchmarkData(selectedView, averageBenchMarkTracker)
    if (isViewChanged) {
      primarySelect = (primaryTracker && this.props.primarySelect) && trackerDataList.filter(t => t.name === this.props.primarySelect.name)[0]
      benchmarkSelect1 = defaultbenchmarks.length > 0 && this.props.benchmarkSelect1 ? trackerDataList.filter(t => t.name === this.props.benchmarkSelect1.name)[0] : null
      benchmarkSelect2 = defaultbenchmarks.length > 1 && this.props.benchmarkSelect2 ? trackerDataList.filter(t => t.name === this.props.benchmarkSelect2.name)[0] : null
      benchmarkSelect3 = defaultbenchmarks.length > 2 && this.props.benchmarkSelect3 ? trackerDataList.filter(t => t.name === this.props.benchmarkSelect3.name)[0] : null
      benchmarkSelect4 = defaultbenchmarks.length > 3 && this.props.benchmarkSelect4 ? trackerDataList.filter(t => t.name === this.props.benchmarkSelect4.name)[0] : null
      averageBenchmarkSelect = averageBenchmarkData.length > 0 && this.props.averageBenchmarkSelect ? averageBenchmarkData.filter(t => t.name === this.props.averageBenchmarkSelect.name)[0] : null
    } else {
      primarySelect = primaryTracker && trackerDataList.filter(t => t.isPrimary)[0]
      benchmarkSelect1 = defaultbenchmarks.length > 0 ? trackerDataList[1] : null
      benchmarkSelect2 = defaultbenchmarks.length > 1 ? trackerDataList[2] : null
      benchmarkSelect3 = defaultbenchmarks.length > 2 ? trackerDataList[3] : null
      benchmarkSelect4 = defaultbenchmarks.length > 3 ? trackerDataList[4] : null
      averageBenchmarkSelect = averageBenchmarkData[0]
    }
    const val = [
      primarySelect && primarySelect.maxValue || 0,
      benchmarkSelect1 && benchmarkSelect1.maxValue || 0,
      benchmarkSelect2 && benchmarkSelect2.maxValue || 0,
      benchmarkSelect3 && benchmarkSelect3.maxValue || 0,
      benchmarkSelect4 && benchmarkSelect4.maxValue || 0,
      averageBenchmarkSelect && averageBenchmarkSelect.maxValue || 0
    ]
    const maxVal = Math.max.apply(Math, val)
    const maxValue = maxVal <= 5 ? 5
    : Math.ceil(maxVal/10) * 10
    this.setState({ maxValue: maxValue})
    const blueLineIndex = primaryTracker ? primaryTracker.metrics.length - 1 : 0
    this.props.handleTrackerData(trackerDataList, primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4, blueLineIndex, maxValue, selectedView, averageBenchmarkData, averageBenchmarkSelect)
  }

  getAverageBenchmarkData = (selectedView, tracker) => {
    let averageBenchmarkData = []
    if (tracker && tracker.average_bench_mark && tracker.average_bench_mark.display_average_benchmark) {
      const trackerBenchmark = tracker.average_bench_mark
      const maxValues = selectedView === TRACKER_LAUNCH_VIEW ? trackerBenchmark.metrics.filter(t => t.day < 0).map(m => m.max) : trackerBenchmark.metrics && trackerBenchmark.metrics.map(m => m.max)
      const minValues = selectedView === TRACKER_LAUNCH_VIEW ? trackerBenchmark.metrics.filter(t => t.day < 0).map(m => m.min) : trackerBenchmark.metrics && trackerBenchmark.metrics.map(m => m.min)
      const data = {
        name: trackerBenchmark.average_benchmark_display_name,
        metrics: trackerBenchmark.metrics,
        data: maxValues,
        labels: selectedView === TRACKER_LAUNCH_VIEW ? trackerBenchmark.metrics.filter(t => t.day < 0).map(m => m.day) : selectedView === TRACKER_PRE_POST_VIEW ? trackerBenchmark.metrics.map(m => m.day) : trackerBenchmark.metrics.map(m => m.date),
        dayZeroData: selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? trackerBenchmark.metrics.filter(t => t.day === 0).map(m => m.max) : '',
        maxValue: Math.max.apply(Math, maxValues),
        minValue: Math.max.apply(Math, minValues)
      }
      averageBenchmarkData.push(data)
      // Support for "None" in benchmark dropdowns
      averageBenchmarkData.push({
        name: NONE,
        metrics: [],
        data: [],
        labels: [],
        isPrimary: false
      })
    }
    return averageBenchmarkData
  }

  getData = (selectedView, benchmarkSelect) => {
    const lookbackDays = moment(new Date()).diff(moment(new Date(benchmarkSelect.lookbackDate)), 'days')
    return selectedView === TRACKER_PRE_POST_VIEW ? benchmarkSelect.metrics.map(m => m.day >= lookbackDays ? null : m.value) : benchmarkSelect.metrics.map(m => m.value)
  }

  getBenchmarkDateFormated = (selectedView, benchmarkSelect) => {
    return selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? benchmarkSelect.metrics.map(m => moment(new Date(benchmarkSelect.lookbackDate)).add(m.day, 'days').format('DD-MM-YYYY')) : benchmarkSelect.metrics.map(m => m.date ? moment(new Date(m.date).toISOString(), 'YYYY-MM-DD').format('DD-MM-YYYY') : moment(new Date(m.date)).format('DD-MM-YYYY'))
  }

  getBenchmarkTT = (dailyEngagementTeasersTrailers, benchmarkSelect) => {
    return (dailyEngagementTeasersTrailers && dailyEngagementTeasersTrailers[benchmarkSelect.trackerEntityId] && dailyEngagementTeasersTrailers[benchmarkSelect.trackerEntityId].teasersAndTrailers && dailyEngagementTeasersTrailers[benchmarkSelect.trackerEntityId].teasersAndTrailers.details) && dailyEngagementTeasersTrailers[benchmarkSelect.trackerEntityId].teasersAndTrailers.details.teasers_and_trailers.map(t => moment(new Date(t.published_at)).format('DD-MM-YYYY'))
  }

  getBenchmarkLaunchDate = (benchmarkSelect) => {
    return moment(new Date(benchmarkSelect.lookbackDate)).format('DD-MM-YYYY')
  }

  getXaxisLabels = (label) => {
    return moment(new Date(label)).format('MMM DD')
  }

  render () {
    const { classes, screenWidth, trackerPlan, primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4, blueLineIndex, maxValue, dailyEngagementTeasersTrailers, selectedView, averageBenchmarkSelect } = this.props
    let trackerTopic = trackerPlan.details && trackerPlan.details.tracker_topic
    let benchMarks = trackerPlan.details && trackerPlan.details.benchmarks || []
    benchMarks = benchMarks.length > 0 ? benchMarks.filter(b => b.is_default_benchmark) : benchMarks
    let dataSet = []
    let data = {}
    if (primarySelect && primarySelect.data.length > 0) {
      const lookbackDays = moment(new Date()).diff(moment(new Date(primarySelect.lookbackDate)), 'days')
      const data = selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? primarySelect.metrics.map(m => m.day >= lookbackDays ? null : m.value) : primarySelect.metrics.map(m => m.value)
      const primaryDateFormated = selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? primarySelect.metrics.map(m => moment(new Date(primarySelect.lookbackDate)).add(m.day, 'days').format('DD-MM-YYYY')) : primarySelect.metrics.map(m => m.date ? moment(new Date(m.date).toISOString(), 'YYYY-MM-DD').format('DD-MM-YYYY') : moment(new Date(m.date)).format('DD-MM-YYYY'))
      const teasersTrailers = dailyEngagementTeasersTrailers && dailyEngagementTeasersTrailers[primarySelect.trackerEntityId]
      const primaryTT = (teasersTrailers && teasersTrailers.teasersAndTrailers && teasersTrailers.teasersAndTrailers.details && teasersTrailers.teasersAndTrailers.details) && teasersTrailers.teasersAndTrailers.details.teasers_and_trailers.map(t => moment(new Date(t.published_at)).format('DD-MM-YYYY'))
      const primaryLaunchDate = moment(new Date(primarySelect.lookbackDate)).format('DD-MM-YYYY')
      const primaryData = {
        label: 'Primary',
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: TRACKER_PRIMARY,
        borderColor: TRACKER_PRIMARY,
        pointBorderColor: TRACKER_PRIMARY,
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: TRACKER_PRIMARY,
        pointHoverBorderColor: TRACKER_PRIMARY,
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: data
      }
      if (primaryDateFormated && primaryDateFormated.length > 0) {
        primaryData.pointBackgroundColor = []
        primaryData.pointRadius = []
        primaryData.pointStyle = []
        primaryDateFormated.map((data, i) => {
          if ([primaryLaunchDate].indexOf(data) > -1) {
            primaryData.pointRadius[i] = 4
            primaryData.pointBackgroundColor[i] = WHITE
            primaryData.pointStyle[i] = 'rectRot'
          }
          else if (primaryTT && primaryTT.length > 0 && primaryTT.indexOf(data) > -1) {
            primaryData.pointRadius[i] = 2
            primaryData.pointBackgroundColor[i] = TRACKER_PRIMARY
            primaryData.pointStyle[i] = 'circle'
          }
          else {
            primaryData.pointRadius[i] = 0
          }
        })
      }
      dataSet.push(primaryData)
    }

    for (let j = 0; j < benchMarks.length; j++) {
      if (benchMarks && benchMarks[j].metrics) {
        let data = []
        let benchmarkDateFormated = []
        let benchmarkTT = []
        let benchmarkLaunchDate = null
        if (j === 0 && benchmarkSelect1 && benchmarkSelect1.data) {
          data = this.getData(selectedView, benchmarkSelect1)
          benchmarkDateFormated = this.getBenchmarkDateFormated(selectedView, benchmarkSelect1)
          benchmarkTT = this.getBenchmarkTT(dailyEngagementTeasersTrailers, benchmarkSelect1)
          benchmarkLaunchDate = this.getBenchmarkLaunchDate(benchmarkSelect1)
       } else if (j === 1 && benchmarkSelect2 && benchmarkSelect2.data) {
          data = this.getData(selectedView, benchmarkSelect2)
          benchmarkDateFormated = this.getBenchmarkDateFormated(selectedView, benchmarkSelect2)
          benchmarkTT = this.getBenchmarkTT(dailyEngagementTeasersTrailers, benchmarkSelect2)
          benchmarkLaunchDate = this.getBenchmarkLaunchDate(benchmarkSelect2)
        } else if (j === 2 && benchmarkSelect3 && benchmarkSelect3.data) {
          data = this.getData(selectedView, benchmarkSelect3)
          benchmarkDateFormated = this.getBenchmarkDateFormated(selectedView, benchmarkSelect3)
          benchmarkTT = this.getBenchmarkTT(dailyEngagementTeasersTrailers, benchmarkSelect3)
          benchmarkLaunchDate = this.getBenchmarkLaunchDate(benchmarkSelect3)
        } else if (j === 3 && benchmarkSelect4 && benchmarkSelect4.data) {
          data = this.getData(selectedView, benchmarkSelect4)
          benchmarkDateFormated = this.getBenchmarkDateFormated(selectedView, benchmarkSelect4)
          benchmarkTT = this.getBenchmarkTT(dailyEngagementTeasersTrailers, benchmarkSelect4)
          benchmarkLaunchDate = this.getBenchmarkLaunchDate(benchmarkSelect4)
        }
        let color = j === 0 ? TRACKER_BENCHMARK1 : j === 1 ? TRACKER_BENCHMARK2 : j === 2 ? TRACKER_BENCHMARK3 : TRACKER_BENCHMARK4
        let benchMarkData = {
          label: `Benchmark${j}`,
          legend: false,
          fill: false,
          lineTension: 0.5,
          borderWidth: 1,
          backgroundColor: color,
          borderColor: color,
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: color,
          pointBackgroundColor: color,
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: color,
          pointHoverBorderWidth: 0,
          pointRadius: 0,
          pointHitRadius: 5,
          data: data
        }
        if (benchmarkDateFormated && benchmarkDateFormated.length > 0) {
          benchMarkData.pointBackgroundColor = []
          benchMarkData.pointRadius = []
          benchMarkData.pointStyle = []
          benchmarkDateFormated.map((data, i) => {
            if ([benchmarkLaunchDate].indexOf(data) > -1) {
              benchMarkData.pointRadius[i] = 4
              benchMarkData.pointBackgroundColor[i] = WHITE
              benchMarkData.pointStyle[i] = 'rectRot'
            } else if (benchmarkTT && benchmarkTT.length > 0 && benchmarkTT.indexOf(data) > -1) {
              benchMarkData.pointRadius[i] = 2
              benchMarkData.pointBackgroundColor[i] = color
              benchMarkData.pointStyle[i] = 'circle'
            } else {
              benchMarkData.pointRadius[i] = 0
            }
          })
        }
        dataSet.push(benchMarkData)
      }
    }

    const averageBenchMarkTracker = selectedView === TRACKER_LAUNCH_VIEW ? this.props.trackerAverageBenchMarkPlan && this.props.trackerAverageBenchMarkPlan.details : selectedView === TRACKER_PRE_POST_VIEW ? this.props.trackerAverageBenchMarkPlan && this.props.trackerAverageBenchMarkPlan.details : this.props.trackerAverageBenchMarkTimelineMetrics && this.props.trackerAverageBenchMarkTimelineMetrics.details
    let averageBenchMarks = averageBenchMarkTracker && averageBenchMarkTracker.average_bench_mark
    const isAverageBenchmarkDisplayed = this.props.trackerAverageBenchMarkPlan.details && this.props.trackerAverageBenchMarkPlan.details.tracker_topic.is_average_benchmark_displayed
    let averageBenchMarkArrMax = []
    let averageBenchMarkArrMin = []
    if (averageBenchmarkSelect && averageBenchmarkSelect.data.length > 0 && averageBenchMarks && averageBenchMarks.metrics && isAverageBenchmarkDisplayed) {
      for (let index =0; index < averageBenchMarks.metrics.length; index++) {
        if (averageBenchMarks.metrics[index].day !== 0) {
          averageBenchMarkArrMax.push(averageBenchMarks.metrics[index].max)
          averageBenchMarkArrMin.push(averageBenchMarks.metrics[index].min)
        }
        if (averageBenchMarks.metrics[index].day === 0 && selectedView === TRACKER_PRE_POST_VIEW) {
          averageBenchMarkArrMax.push(averageBenchMarks.metrics[index].max)
          averageBenchMarkArrMin.push(averageBenchMarks.metrics[index].min)
        }
      }
      const averageBenchMarkDataMax = {
        label: 'AverageMax',
        legend: false,
        fill: '+1',
        lineTension: 0.5,
        borderWidth: 1,
        backgroundColor: (context) => {
          const ctx = context.chart.ctx
          const gradient = ctx.createLinearGradient(0, 0, 0, context.chart.height ? context.chart.height : 200)
          gradient.addColorStop(0, 'rgba(255, 183, 0, 0.4)')
          gradient.addColorStop(1, 'rgba(255, 183, 0, 0.1)')
          return gradient
        },
        borderColor: AVERAGE_BENCHMARK,
        pointBorderWidth: 0,
        pointHoverRadius: 2,
        pointHoverBackgroundColor: TRACKER_PRIMARY,
        pointHoverBorderColor: TRACKER_PRIMARY,
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: averageBenchMarkArrMax
      }
      if (averageBenchMarks && averageBenchMarks.metrics) {
        averageBenchMarkDataMax.pointBackgroundColor = []
        averageBenchMarkDataMax.pointRadius = []
        averageBenchMarkDataMax.pointStyle = []
        averageBenchMarks.metrics.map((data, i) => {
          if (data.day === 0) {
            averageBenchMarkDataMax.pointBorderColor = AVERAGE_BENCHMARK
            averageBenchMarkDataMax.pointRadius[i] = 4
            averageBenchMarkDataMax.pointBackgroundColor[i] = WHITE
            averageBenchMarkDataMax.pointStyle[i] = 'rectRot'
          }
          else {
            averageBenchMarkDataMax.pointRadius[i] = 0
          }
        })
      }
      dataSet.push(averageBenchMarkDataMax)

      const averageBenchMarkDataMin = {
        label: 'AverageMin',
        legend: false,
        fill: false,
        lineTension: 0.5,
        borderWidth: 0,
        borderColor: AVERAGE_BENCHMARK,
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        pointBorderWidth: 0,
        pointHoverRadius: 0,
        pointHoverBorderWidth: 0,
        pointRadius: 0,
        pointHitRadius: 5,
        data: averageBenchMarkArrMin
      }
      dataSet.push(averageBenchMarkDataMin)
    }

    let plugins = []
    let lookBackDaysLabels = []
    let lookForwardDaysLabels = []
    let launchViewLabels = []
    const timelineViewLabels = DateHelpers.getDateArry(trackerTopic.timeline_view_start_date, trackerTopic.timeline_view_end_date)
    for (let i = trackerTopic.days_lookback; i >= 0; i--) {
      lookBackDaysLabels.push(-i)
      if (i !== 0) { launchViewLabels.push(-i) }
    }
    for (let i = 1; i <= trackerTopic.launch_view_look_forward; i++) {
      lookForwardDaysLabels.push(i)
    }
    lookBackDaysLabels = selectedView === TRACKER_PRE_POST_VIEW ? lookBackDaysLabels.concat(lookForwardDaysLabels)
    : selectedView === TRACKER_TIMELINE_VIEW ? (primarySelect && timelineViewLabels) || []
    : (primarySelect && launchViewLabels) || []
    if (dataSet.length > 0) {
      data = {
        labels: lookBackDaysLabels,
        datasets: dataSet
      }
      plugins = [{
        beforeRender: function (x) {
          let c = x.chart
          let dataset = x.data.datasets[0]
          let gradientFill = c.ctx.createLinearGradient(0, 0, 0, c.height)
          gradientFill.addColorStop(0, 'rgba(0, 186, 169, 0.5)')
          gradientFill.addColorStop(0.5, 'rgba(0, 186, 169, 0.25)')
          gradientFill.addColorStop(1, 'rgba(0, 186, 169, 0)')
          let model = (x.data.datasets[0] && x.data.datasets[0]._meta[Object.keys(dataset._meta)[0]].dataset._model)
          if (model) {
            model.backgroundColor = gradientFill
          }
          dataset = x.data.datasets[3]
          gradientFill = c.ctx.createLinearGradient(0, 0, 0, c.height)
          gradientFill.addColorStop(0, 'rgba(255, 153, 0, 0.15)')
          gradientFill.addColorStop(0.5, 'rgba(255, 153, 0, 0.15)')
          gradientFill.addColorStop(1, 'rgba(255, 153, 0, 0.15)')
          model = (x.data.datasets[3] && x.data.datasets[3]._meta[Object.keys(dataset._meta)[0]].dataset._model)
          if (model) {
            model.backgroundColor = gradientFill
          }
        }
      }]
    }
    const val = [
      this.props.primarySelect && this.props.primarySelect.maxValue || 0,
      this.props.benchmarkSelect1 && this.props.benchmarkSelect1.maxValue || 0,
      this.props.benchmarkSelect2 && this.props.benchmarkSelect2.maxValue || 0,
      this.props.benchmarkSelect3 && this.props.benchmarkSelect3.maxValue || 0,
      this.props.benchmarkSelect4 && this.props.benchmarkSelect4.maxValue || 0,
      this.props.averageBenchmarkSelect && this.props.averageBenchmarkSelect.maxValue || 0
    ]
    const maxVal = Math.max.apply(Math, val)
    let maxValue1 = maxVal <= 5 ? 5
    : Math.ceil(maxVal/10) * 10
    const updateChartTicks = (scale, that) => { // Function to setting max Y-axis value and keeping steps correct
      var incrementAmount = 0
      var previousAmount = 0
      var newTicks = []
      newTicks = scale.ticks
      for (var x=0; x<newTicks.length; x++) {
        incrementAmount = (previousAmount - newTicks[x])
        previousAmount = newTicks[x]
      }
      if (newTicks.length > 2) {
        if (newTicks[0] - newTicks[1] != incrementAmount) {
          var tick = newTicks[0]
          newTicks[0] = newTicks[1] + incrementAmount
          if (tick > newTicks[0]) {
            newTicks.unshift(newTicks[0] + incrementAmount, 0)
          }
          maxValue1 = newTicks[0] //newTicks[1] + incrementAmount
          that.props.handleMaxValue(maxValue1)
        }
      }
      return newTicks
    };
    const that = this
    const options = {
      animation: false,
      width: '80%',
      maintainAspectRatio: true,
      responsive: true,
      legend: {
        display: false
      },
      tooltips: {
        enabled: false,
        mode: 'index',
        intersect: false,
        titleFontSize: 10,
        bodyFontSize: 10,
        position: 'average',
        backgroundColor: '#1a1c1f',
        custom: function (tooltipModel) {
          // Tooltip Element
          var tooltipEl = document.getElementById('chartjs-tooltip');
          var labels = tooltipModel.body
          // `this` will be the overall tooltip
          var position = this._chart.canvas.getBoundingClientRect();
          var pos = (position.width/4) * 3;

          // Create element on first render
          if (!tooltipEl) {
              tooltipEl = document.createElement('div');
              tooltipEl.id = 'chartjs-tooltip';
              tooltipEl.innerHTML = '<table></table>';
              document.body.appendChild(tooltipEl);
          }

          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = 0;
              return;
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform');
          if (tooltipModel.yAlign) {
              tooltipEl.classList.add(tooltipModel.yAlign);
          } else {
              tooltipEl.classList.add('no-transform');
          }
          // Set Text
          if (tooltipModel.dataPoints) {
              var bodyLines = tooltipModel.dataPoints;
              var labelColors = tooltipModel.labelColors
              var innerHtml = '<tbody>';
              bodyLines.forEach(function (body, i) {
                if (labels[i].lines[0].indexOf('AverageMin') === -1) { // dont show the average benchmark metrics in tooltip
                  var date = labels[i].lines[0].indexOf('Primary') > -1 ? primarySelect.lookbackDate
                  : labels[i].lines[0].indexOf('Benchmark0') > -1 ? benchmarkSelect1.lookbackDate
                  : labels[i].lines[0].indexOf('Benchmark1') > -1 ? benchmarkSelect2.lookbackDate
                  : labels[i].lines[0].indexOf('Benchmark2') > -1 ? benchmarkSelect3.lookbackDate
                  : labels[i].lines[0].indexOf('Benchmark3') > -1 ? benchmarkSelect4.lookbackDate
                  : primarySelect.lookbackDate
                  var dateWithoutTime = moment(DateHelpers.getDateWithoutTime(date))
                  var newDate = selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? date && moment(dateWithoutTime, 'DD-MM-YYYY').add(body.xLabel, 'days').format('MMM DD, YYYY') : moment(new Date(body.xLabel)).format('MMM DD, YYYY')
                  newDate = (selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW) && labels[i].lines[0].indexOf('AverageMax') > -1 ? body.xLabel : newDate
                  var style = 'border-color:' + labelColors[i].borderColor;
                  style += '; background-color: #FFFFFF; border-width: 1px; border-style: solid; box-sizing: border-box;border-radius: 3px; padding: 2px; margin-top: 2px; display: flex;'; // width: 130px;
                  var xLabel = selectedView === TRACKER_LAUNCH_VIEW || selectedView === TRACKER_PRE_POST_VIEW ? body.xLabel : moment(new Date(body.xLabel)).diff(moment(new Date(date)), 'days')
                  xLabel = selectedView === TRACKER_TIMELINE_VIEW && labels[i].lines[0].indexOf('AverageMax') > -1 ? moment(new Date(body.xLabel)).format('MMM DD, YYYY') : xLabel
                  var span = ''
                  if (tooltipModel.caretX > pos) {
                    span = '<div style="' + style + '"><div style="width: 6px; height: 6px; margin-left: 4px; margin-right: 4px; border-radius: 50%; background: '+ labelColors[i].borderColor +'; margin-top: 12%;"></div><div>'
                    span = labels[i].lines[0].indexOf('AverageMax') > -1 ? span + '<div style="font-size: 14px; color: #000000; line-height: 14px; letter-spacing: 0.1px; font-family: Uni Sans Regular; font-weight: 400; padding: 2px;">Range: ' + TableFormats.trackerFormatKM(bodyLines[bodyLines.length - 1].yLabel) + ' to ' + TableFormats.trackerFormatKM(body.yLabel) + '</div>' : span + '<div style="font-size: 14px; color: #000000; line-height: 14px; letter-spacing: 0.1px; font-family: Uni Sans Regular; font-weight: 400; padding: 2px; text-align: right;">'+ TableFormats.trackerFormatKM(body.yLabel) + ' engagements</div>'
                    span = span + '<div style="display: flex; align-items: center; justify-content: flex-end; text-align: right; font-size: 14px; color: #000000; line-height: 14px; letter-spacing: 0.1px; font-family: Uni Sans Light; font-weight: 300; padding: 2px; text-align: right; align: right;">'
                    span = (labels[i].lines[0].indexOf('AverageMax') > -1 && selectedView === TRACKER_TIMELINE_VIEW) ? span + '<div>'+ xLabel + '</div>' : span + '<div>'+ xLabel + 'd</div>'
                    span = labels[i].lines[0].indexOf('AverageMax') === -1 ? span + '<div style="width: 2px; height: 2px; background: #333333; border-radius: 50%; right: 5px; margin-left: 3px; margin-right: 4px"></div>' : span
                    span = labels[i].lines[0].indexOf('AverageMax') === -1 ? span + '<div>' + newDate + '</div>' : span
                    span = labels[i].lines[0].indexOf('AverageMax') === -1 ? span + '</div></div></div>' : span;
                  } else {
                    span = '<div style="' + style + '"><div style="width: 6px; height: 6px; margin-left: 4px; margin-right: 4px; border-radius: 50%; background: '+ labelColors[i].borderColor +'; margin-top: 12%;"></div><div>'
                    span = labels[i].lines[0].indexOf('AverageMax') > -1 ? span + '<div style="font-size: 14px; color: #000000; line-height: 14px; letter-spacing: 0.1px; font-family: Uni Sans Regular; font-weight: 400; padding: 2px;">Range: ' + TableFormats.trackerFormatKM(bodyLines[bodyLines.length - 1].yLabel) + ' to ' + TableFormats.trackerFormatKM(body.yLabel) + '</div>' : span + '<div style="font-size: 14px; color: #000000; line-height: 14px; letter-spacing: 0.1px; font-family: Uni Sans Regular; font-weight: 400; padding: 2px;">'+ TableFormats.trackerFormatKM(body.yLabel) + ' engagements</div>'
                    span = span + '<div style="display: flex; align-items: center; font-size: 14px; color: #000000; line-height: 14px; letter-spacing: 0.1px; font-family: Uni Sans Light; font-weight: 300; padding: 2px">'
                    span = (labels[i].lines[0].indexOf('AverageMax') > -1 && selectedView === TRACKER_TIMELINE_VIEW) ? span + '<div>'+ xLabel + '</div>' : span + '<div>'+ xLabel + 'd</div>'
                    span = labels[i].lines[0].indexOf('AverageMax') === -1 ? span + '<div style="width: 2px; height: 2px; background: #333333; border-radius: 50%; right: 5px; margin-left: 3px; margin-right: 4px"></div>' : span
                    span = labels[i].lines[0].indexOf('AverageMax') === -1 ? span + '<div>' + newDate + '</div>' : span
                    span = labels[i].lines[0].indexOf('AverageMax') === -1 ? span + '</div></div></div>' : span;
                  }
                  innerHtml += '<tr><td>' + span + '</td></tr>';
                }
              });
              innerHtml += '</tbody>';
              var tableRoot = tooltipEl.querySelector('table');
              tableRoot.innerHTML = innerHtml;
          }

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = 'absolute';
          if (tooltipModel.caretX > pos) {
            tooltipEl.style.left = tooltipModel.caretX + 75 + 'px';
          } else {
            tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
          }
          tooltipEl.style.top = position.top + window.pageYOffset + 'px';
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
          tooltipEl.style.pointerEvents = 'none';
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        yAxes: [{
          gridLines: {
            display: true,
            drawBorder: false
          },
          afterBuildTicks: function (scale) {
            scale.ticks = updateChartTicks(scale, that);
          },
          ticks: {
            display: true,
            fontSize: 12,
            fontColor: '#A7A9AC',
            fontFamily: 'Uni Sans Regular',
            max: maxValue,
            min: 0,
            stepSize: maxValue <= 5 ? 1
            : maxValue <= 10 ? 2
            : maxValue <= 20 ? 5
            : maxValue <= 30 ? 5
            : maxValue <= 40 ? 10
            : maxValue <= 50 ? 10
            : maxValue <= 100 ? 20
            : maxValue <= 300 ? 50
            : maxValue <= 1000 ? 100
            : maxValue <= 3000 ? 200
            : maxValue <= 5000 ? 500
            : maxValue <= 10000 ? 1000
            : maxValue <= 20000 ? 2000 : 5000,
            callback: function (label) {
              if (label >= 1000) {
                const lbl = label / 1000
                const lblR = label % 1000
                const val = lblR === 0 ? `${lbl},000` : lblR % 100 === 0 ? //lblR + 1000
                `${Math.trunc(lbl)},${Math.round(lblR / 100)}00`
                : `${Math.trunc(lbl)},${Math.round(lblR / 100)}00`
                return val
              } else if (label >= 100) {
                const lbl = label / 100
                const lblR = label % 100
                return lblR === 0 ? `${lbl}00` : lblR === 50 ? `${Math.trunc(lbl)}50` : ''//`${Math.round(lbl)}00`
              } else if (label > 30 && label < 100) {
                const lbl = label / 10
                const lblR = label % 10
                return lblR === 0 ? `${lbl}0` : `${Math.round(lbl)}0`
              }
              return label
            }
          }
        }],
        xAxes: [{
          ticks: {
            fontSize: 12,
            fontColor: '#A7A9AC',
            fontFamily: 'Uni Sans Regular',
            autoSkip: false,
            maxRotation: 0,
            minRotation: 0,
            callback: function (label) {
              switch (selectedView) {
                case TRACKER_LAUNCH_VIEW:
                  if (screenWidth > 480) {
                    if (label === -100 || label === -90 || label === -80 || label === -70 || label === -60 || label === -50 || label === -40 || label === -30 || label === -20 || label === -10 || label === -5) {
                      return `${label} days`
                    } else if (label === -1) {
                      return '-1'
                    }
                  }
                  break
                case TRACKER_PRE_POST_VIEW:
                  if (screenWidth > 480) {
                    if ((label < -14 && label % 7 == 0) || (label > 14 && label % 7 == 0)) {
                      return `${label / 7} weeks`
                    } else if (label === -7 || label === -14 || label === 7 || label === 14) {
                      return `${label} days`
                    } else if (label === 0) {
                      return 'Launch'
                    }
                  } else {
                    if (label === -70 || label === -50 || label === -30 || label === -10) {
                      return `${label} d`
                    } else if (label === 0) {
                      return '0'
                    } else if (label > 0) {
                      return label
                    }
                  }
                  break
                case TRACKER_TIMELINE_VIEW:
                  if (timelineViewLabels.length >= 200) {
                    return new Date(label).getDate() === 1 ? that.getXaxisLabels(label) : ''
                  }
                  else if (timelineViewLabels.length > 100 && timelineViewLabels.length < 200) {
                    return new Date(label).getDate() === 1 || new Date(label).getDate() === 15 ? that.getXaxisLabels(label) : ''
                  }
                  else {
                    return new Date(label).getDay() === 1 ? that.getXaxisLabels(label) : ''
                  }
              }
            }
          },
          gridLines: {
            display: false,
            drawBorder: false
          }
        }]
      },
      lineAtIndex: [blueLineIndex]
    }

    if (dataSet.length === 0) {
      return null
    }
    console.log('-====data', data );
    return (
      <Grid className={classes.genreInterestChart}>
        <Line
          data={data}
          options={options}
          plugins={plugins}
          width={screenWidth >= 480 ? 500 : 100}
          height={screenWidth >= 480 ? 150: 125}/>
      </Grid>
    )
  }
}

export default withStyles(styles)(DailyEngagement)